import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PRODUCTION_ORIGIN = "https://letsallsingtogether.com";

/**
 * Keeps <link rel="canonical"> self-referencing on every client-side route
 * change. The server already stamps the correct canonical into the raw
 * HTML on first load (see `_set_canonical` in server.py) — this covers the
 * SPA case: navigating via React Router (no full page reload) never
 * refetches that HTML, so without this the DOM would keep showing
 * whichever page was first loaded as "canonical" for every route after.
 */
export default function CanonicalUrl() {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = pathname === "/" ? "/" : pathname.replace(/\/+$/, "");
    const href = `${PRODUCTION_ORIGIN}${path}`;
    const link = document.head.querySelector('link[rel="canonical"]');
    if (link) link.setAttribute("href", href);
  }, [pathname]);

  return null;
}
